import { AuthWrapper } from '@app/core/auth/authentication';
import { AppRootRoutes } from '@app/core/auth/flow/AppRootRoutes';
import { ErrorBoundary } from '@app/core/error/ErrorBoundary';
import { NotificationsContainer } from '@app/core/notifications';
import { RouterWrapper } from '@app/core/routing/RouterWrapper';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { SplashLoader } from '@ui/components';
import { HelmetProvider } from 'react-helmet-async';
import { GrowthBookProviderWrapper } from '../integrations/growthbook/GrowthBookProviderWrapper';
import { queryClient } from '../integrations/react-query/react-query';
import { AppThemeProvider } from '../ui/AppThemeProvider';
import { FontSwitcher } from '../ui/FontSwitcher';
import { HtmlTags } from './HtmlTags';
import { LanguageProvider } from './LanguageProvider';
import { ZustandPersistGate } from './ZustandPersistGate';

// to preserve import when tools are commented out
const _ReactQueryDevtools = ReactQueryDevtools;

export function Root() {
  return (
    <GrowthBookProviderWrapper>
      <HelmetProvider>
        <LanguageProvider>
          <AppThemeProvider>
            {/* <CssBaseline /> */}
            <ErrorBoundary errScreen>
              <HtmlTags />
              {/* <BreakpointChip /> */}
              <FontSwitcher />
              <ZustandPersistGate fallback={<SplashLoader />}>
                <QueryClientProvider client={queryClient}>
                  <RouterWrapper>
                    <NotificationsContainer />
                    <AuthWrapper>
                      <AppRootRoutes />
                    </AuthWrapper>
                  </RouterWrapper>
                  {/* <_ReactQueryDevtools initialIsOpen={false} buttonPosition={'top-left'} /> */}
                </QueryClientProvider>
              </ZustandPersistGate>
            </ErrorBoundary>
          </AppThemeProvider>
        </LanguageProvider>
      </HelmetProvider>
    </GrowthBookProviderWrapper>
  );
}
